var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: "sidebar",
        class: [
          "sidebar",
          {
            "close-sidebar": _vm.currentUrl.includes(_vm.urls.services),
            "lang-en": _vm.$i18n.locale === "en"
          }
        ]
      },
      [
        _c(
          "div",
          {
            staticClass: "yektanet-brand-container",
            staticStyle: { "font-weight": "700" }
          },
          [
            _c("accounts-logo-icon"),
            _vm._v(
              "\n      " + _vm._s("" + _vm.$t("account_management")) + "\n    "
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.items, function(item) {
          return _c(
            "a",
            {
              key: item.url,
              class: [
                "p-0 sidebar-item btn btn-link",
                {
                  selected: _vm.currentUrl.includes(item.url)
                }
              ],
              attrs: { href: item.url }
            },
            [
              _c(
                "i",
                {
                  class: [
                    "sidebar-item-icon font-5 position-relative mx-1",
                    item.icon
                  ],
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "left",
                    title: item.title.desktop
                  }
                },
                [
                  item.hasRedDot
                    ? _c("span", { staticClass: "red-dot" })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.title.desktop))])
            ]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mobile-sidebar d-flex d-md-none flex-row-reverse" },
      _vm._l(
        _vm.items.filter(function(e) {
          return e.title.mobile
        }),
        function(item) {
          return _c(
            "a",
            {
              key: item.url,
              class: [
                "p-0 sidebar-item btn btn-link d-flex flex-column py-2 justify-content-between",
                {
                  selected: _vm.currentUrl.includes(item.url)
                }
              ],
              attrs: { href: item.url },
              on: {
                click: function($event) {
                  return _vm._sidebar("close")
                }
              }
            },
            [
              _c(
                "i",
                {
                  class: [
                    "sidebar-item-icon position-relative mb-2 mt-1",
                    item.icon
                  ]
                },
                [
                  item.hasRedDot
                    ? _c("span", { staticClass: "red-dot" })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.title.mobile))])
            ]
          )
        }
      ),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }